import React from "react";
import { Helmet } from "react-helmet";
import MPHFooterPrimary from "src/components/actionPerformers/MPHFooterPrimary/MPHFooterPrimary";
import MPHFooterSecondary from "src/components/actionPerformers/MPHFooterSecondary/MPHFooterSecondary";
import MPHHeaderMain from "src/components/actionPerformers/MPHHeaderMain/MPHHeaderMain";
import MPHProfileForms from "src/components/actionPerformers/MPHProfileForms/MPHProfileForms";

const MyProfile = () => {
  return (
    <>
      <Helmet>
        <title>Manage Your Profile - Stay Rewarded</title>
        <meta name="description" content="Update your Stay Rewarded member profile. Keep your information current to maximize your My Place Hotels loyalty benefits." />
      </Helmet>
      <MPHHeaderMain active="/profile" />
      <div className="margin-top">
        {/* <MPHBanner
          url={banner}
          header={"Where will you go next?"}
          helperText={""}
        /> */}
        <div className="my-profile">
          <MPHProfileForms />
        </div>
        <MPHFooterPrimary />
        <MPHFooterSecondary />
      </div>
    </>
  );
};

export default MyProfile;
